import Fetch from './fetch';
import config from './config';

const fetch = new Fetch();
const TYPE = {
    "video": 187,
    "download": 258,
    "coupon": 244,
    "banner": 290
};
function fetchGdt(appid, account_id, position_id, imei, guid, type, order_data, login_type, app_id, openid, custom_channel, screen_width, screen_height, oaid, tdid, adv_width, adv_height) {
    return new Promise((resolve, reject) => {
        fetch.post(`extfe/fetchQianTuAdvEasy?appid=${appid}`, {
            position_id,
            position_type: TYPE[type],
            guid: guid,
            imei,
            account_id,
            order_data,
            app_id, login_type, openid, custom_channel, screen_width, screen_height, oaid, tdid, adv_width, adv_height
        })
            .then(resp => {
                if (resp.ret === 0) {
                    resolve(resp.data);
                } else {
                    reject(resp)
                }
            })
            .catch(e => {
                console.log("fetchGdt失败", e);
                reject(e)
            });
    })
}

function stat(appid, account_id, position_id, phase, context = [], imei, guid, token, order_data) {
    return new Promise((resolve, reject) => {
        fetch.post(`extfe/statQianTuAdvEasy?appid=${appid}`, {
            position_id,
            guid,
            account_id,
            phase,
            context,
            imei,
            order_data
        }, {
            authorization: token
        })
            .then(resp => {
                if (resp === 0) {
                    console.log("上报" + phase + "成功");
                    resolve(resp);
                } else {
                    reject(resp);
                }
            })
            .catch(e => {
                reject(e);
            });
    })
}

function initConfig(appid) {
    return fetch.get('extfe/getH5HomePageAdvConfByProductId', {
        appid,
        all: true
    })
}


export {fetchGdt, stat, initConfig};